import { readonly, shallowRef } from "vue";

import { jobs as jobsApi } from "~/api";

/**
 * Composable for fetching a single job's detail.
 *
 * @param {string} jobId
 * @returns {{
 *   job: import('vue').DeepReadonly<import('vue').ShallowRef<object|null>>,
 *   loading: import('vue').DeepReadonly<import('vue').ShallowRef<boolean>>,
 *   error: import('vue').DeepReadonly<import('vue').ShallowRef<string|null>>,
 *   fetchJobDetail: Function,
 *   clearError: Function
 * }}
 */
export function useJobDetail(jobId) {
  const _job = shallowRef(null);
  const _loading = shallowRef(false);
  const _error = shallowRef(null);

  async function fetchJobDetail() {
    _loading.value = true;
    _error.value = null;

    try {
      _job.value = await jobsApi.show({ params: { id: jobId } });
    } catch (err) {
      _error.value = err.message || "Oops, something went wrong!";
    } finally {
      _loading.value = false;
    }
  }

  function clearError() {
    _error.value = null;
  }

  return {
    clearError,
    error: readonly(_error),
    fetchJobDetail,
    job: readonly(_job),
    loading: readonly(_loading)
  };
}
